<template>
  <div>
    <el-dialog title="项目合并" :visible.sync="showDialog"   width="1380px" :destroy-on-close="true" :append-to-body="true"
               :before-close="cancel">
      <!-- 搜索框 -->
      <div style="margin-bottom: 20px; background-color: #f5f7fa; padding: 15px; border-radius: 4px;">
        <el-form :inline="true" :model="mergeSearchForm" class="demo-form-inline">
          <el-form-item label="项目ID">
            <el-input v-model="mergeSearchForm.projectId" placeholder="请输入项目ID" clearable></el-input>
          </el-form-item>
          <el-form-item label="合同号">
            <el-input v-model="mergeSearchForm.contractNumber" placeholder="请输入合同号" clearable></el-input>
          </el-form-item>
          <!-- 添加生物序列分类方法选择器 -->
          <el-form-item label="分类方法">
            <el-select v-model="mergeSearchForm.otuOrAsv" placeholder="请选择" clearable>
              <el-option label="全部" value=""></el-option>
              <el-option label="OTU" value="OTU"></el-option>
              <el-option label="ASV" value="ASV"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="searchMergeProject">查询</el-button>
            <el-button @click="resetMergeSearch">重置</el-button>
          </el-form-item>
        </el-form>
      </div>

      <div style="display: flex; justify-content: space-between;" v-loading="loadingMergeProject">
        <!-- 左侧项目列表 -->
        <div style="width: 55%; margin-right: 20px;min-width: 880px;" v-loading="loadingMergeProject">
          <el-table
              ref="elTable"
              :data="filteredMergeProjectData"
              style="width: 100%"
              border
              @selection-change="handleSelectionChange">
            <el-table-column
                type="selection"
                width="55"
                align="center"
                :selectable="row => (row.projectsRow.mergeStatus !== 1 && row.projectsRow.mergeStatus !== 2) &&
                                 (selectedProjectIds.length < 10 || selectedProjectIds.includes(row.projectsRow.projectId)) &&
                                 row.projectsRow.projectType"
                :select-all="false">
            </el-table-column>
            <el-table-column
                prop="projectsRow.projectId"
                label="项目ID"
                width="180">
              <template slot-scope="{row}">
                {{ row.projectsRow.projectId }}
              </template>
            </el-table-column>
            <el-table-column
                prop="projectsRow.contractNumber"
                label="合同号"
                width="180">
              <template slot-scope="{row}">
                {{ row.projectsRow.contractNumber }}
              </template>
            </el-table-column>
            <el-table-column
                prop="projectsRow.projectType"
                label="引物类型"
                width="180">
              <template slot-scope="{row}">
                {{ row.projectsRow.projectType }}
              </template>
            </el-table-column>
            <el-table-column
                prop="projectsRow.mergeStatus"
                label="合并状态"
                width="100">
              <template slot-scope="{row}">
                <el-tag
                    :type="getMergeStatusType(row.projectsRow.mergeStatus)"
                    effect="dark"
                    size="small">
                  {{ getMergeStatusText(row.projectsRow.mergeStatus) }}
                </el-tag>
              </template>
            </el-table-column>
            <!-- 添加生物序列分类方法列 -->
            <el-table-column
                prop="otuOrAsv"
                label="生物序列分类方法"
                width="150">
              <template slot-scope="{row}">
                <el-tag
                    :type="getOtuAsvType(row.otuOrAsv)"
                    effect="light"
                    size="small">
                  {{ row.otuOrAsv || '未知' }}
                </el-tag>
              </template>
            </el-table-column>
          </el-table>

          <div class="pagination-container" style="margin-top: 15px; text-align: right;">
            <el-pagination
                @size-change="val => handleMergePagePagination({currentNum: mergePage.currentNum, pageSize: val})"
                @current-change="val => handleMergePagePagination({currentNum: val, pageSize: mergePage.pageSize})"
                :current-page="mergePage.currentNum"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="mergePage.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="mergePage.total">
            </el-pagination>
          </div>
        </div>

        <!-- 右侧已选项目列表 -->
        <div style="width: 40%;">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span style="font-weight: bold;">已选项目列表 ({{ selectedProjectIds.length }}/10)</span>
              <el-button style="float: right; padding: 3px 0" type="text"
                         @click="selectedProjectIds = []">清空
              </el-button>
            </div>
            <div v-if="selectedProjectIds.length === 0" style="color: #909399; text-align: center; padding: 40px 0;">
              请选择要合并的项目
            </div>
            <el-scrollbar style="height: 350px; min-height: 350px;" v-else>
              <div style="padding: 10px; margin-bottom: 15px; background-color: #f0f9eb; border-radius: 4px;"
                   v-if="selectedProjectType">
                <el-alert
                    title="已选项目类型限制"
                    type="info"
                    :description="`当前只能选择相同生物序列分类方法(${selectedProjectType.otuOrAsv})和相同引物类型(${selectedProjectType.projectType})的项目进行合并`"
                    show-icon>
                </el-alert>
              </div>
              <div v-for="(id, index) in selectedProjectIds" :key="index"
                   style="display: flex; justify-content: space-between; margin-bottom: 15px; padding: 5px; align-items: center; border-bottom: 1px dashed #ebeef5;">
                <div style="display: flex; align-items: center;">
                  <el-tag size="medium" type="primary" effect="dark">{{ id }}</el-tag>
                  <el-tag style="margin-left: 5px;" size="small" :type="getOtuAsvType(getProjectTypeById(id).otuOrAsv)"
                          effect="light">
                    {{ getProjectTypeById(id).otuOrAsv || '未知' }}
                  </el-tag>
                </div>
                <el-button type="danger" size="mini" icon="el-icon-close" circle
                           @click="selectedProjectIds.splice(index, 1)"></el-button>
              </div>
            </el-scrollbar>
            <div
                style="margin-top: 15px; text-align: center; padding: 10px; background-color: #f5f7fa; border-radius: 4px;"
                v-if="selectedProjectIds.length > 0">
              <span :style="getSelectedCountStyle()">
                已选择 {{ selectedProjectIds.length }} 个项目
                <span v-if="selectedProjectIds.length < 2"
                      style="color: #E6A23C; font-size: 12px;"> (至少选择2个)</span>
                <span v-if="selectedProjectIds.length >= 10" style="color: #F56C6C; font-size: 12px;"> (已达上限)</span>
              </span>
            </div>
          </el-card>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="cancel()">取 消</el-button>
        <el-button type="primary" @click="submitMergeProject" :loading="loadingMergeProject"
                   :disabled="selectedProjectIds.length < 2">确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import {projectList, projectMerge} from "@/api/bz";

export default {
  name: "MergeProjectDialog",
  props: {
    showDialog: {
      default: false
    },
  },
  computed:{
    // 计算当前选中的项目类型
    selectedProjectType() {
      if (this.selectedProjectIds.length === 0) {
        return null
      }

      // 获取第一个项目的类型
      const firstProject = this.mergeProjectData.find(item => item.projectsRow.projectId === this.selectedProjectIds[0])
      if (!firstProject) {
        // 如果当前页找不到，从缓存中查找
        const cachedProject = this.selectedProjectsCache.find(item => item.id === this.selectedProjectIds[0])
        if (cachedProject) {
          return {
            otuOrAsv: cachedProject.otuOrAsv,
            projectType: cachedProject.projectType
          }
        }
        return null
      }

      return {
        otuOrAsv: firstProject.otuOrAsv,
        projectType: firstProject.projectsRow.projectType
      }
    },
    // 前端筛选项目数据
    filteredMergeProjectData() {
      // 如果没有选择筛选类型，返回全部数据
      if (!this.mergeSearchForm.otuOrAsv) {
        return this.mergeProjectData
      }

      // 根据选择的otuOrAsv类型筛选数据
      return this.mergeProjectData.filter(item =>
          item.otuOrAsv === this.mergeSearchForm.otuOrAsv
      )
    }
  },
  data(){
    return{
      showMergeDialog: false, // 项目合并弹框
      mergeSearchForm: { // 项目合并搜索表单
        projectId: '',
        contractNumber: '',
        otuOrAsv: ''
      },
      mergePage: { // 项目合并分页
        total: 0,
        pageSize: 10,
        currentNum: 1
      },
      mergeProjectData: [], // 项目合并数据
      selectedProjectIds: [], // 选中的项目ID
      loadingMergeProject: false, // 加载中
      selectedProjectsCache: [], // 选中项目的缓存，包含id和type
    }
  },
  mounted() {
    this.getMergeProjectData()
  },
  methods: {
    // 点击合并项目按钮
    handleMergeProject() {
      this.showMergeDialog = true
      this.selectedProjectIds = []
      this.selectedProjectsCache = [] // 添加这行初始化缓存
      this.getMergeProjectData()
    },

    // 获取合并项目列表数据
    async getMergeProjectData() {
      this.loadingMergeProject = true
      var sendData = {
        page: {
          current: this.mergePage.currentNum,
          size: this.mergePage.pageSize,
        },
        condition: {}
      }

      // 添加搜索条件
      if (this.mergeSearchForm.projectId) {
        sendData.condition.projectId = this.mergeSearchForm.projectId
      }

      if (this.mergeSearchForm.contractNumber) {
        sendData.condition.contractNumber = this.mergeSearchForm.contractNumber
      }

      // 移除otuOrAsv筛选条件，改为前端筛选

      const res = await projectList(sendData)
      this.loadingMergeProject = false

      if (res && res.code === 200) {
        var pageData = res.data
        this.mergeProjectData = pageData.data
        this.mergePage.total = pageData.totalNum
        this.mergePage.pageSize = pageData.pageSize
        this.mergePage.currentNum = pageData.currentNum

        // 更新表格选中状态，保持已选项目的选中状态
        this.$nextTick(() => {
          this.updateTableSelection()
        })
      }
    },

    // 合并项目分页变动
    handleMergePagePagination(page) {
      this.mergePage.currentNum = page.currentNum
      if (page.pageSize) {
        this.mergePage.pageSize = page.pageSize
      } else {
        this.mergePage.pageSize = this.mergePage.total
      }
      this.getMergeProjectData()
    },

    // 选择项目
    handleSelectProject(projectId) {
      const index = this.selectedProjectIds.indexOf(projectId)
      if (index > -1) {
        this.selectedProjectIds.splice(index, 1)
      } else {
        // 添加数量限制
        if (this.selectedProjectIds.length >= 10) {
          this.$message.warning('最多只能选择10个项目进行合并')
          return
        }
        this.selectedProjectIds.push(projectId)
      }
      // 更新表格选中状态
      this.updateTableSelection()
    },

    // 处理表格选择变化
    handleSelectionChange(selection) {
      // 获取当前页新选中的项目ID和类型
      const currentSelected = selection.map(item => ({
        id: item.projectsRow.projectId,
        otuOrAsv: item.otuOrAsv,
        projectType: item.projectsRow.projectType
      }))

      // 更新选中项目的缓存
      currentSelected.forEach(item => {
        if (!this.selectedProjectsCache.some(cache => cache.id === item.id)) {
          this.selectedProjectsCache.push(item)
        }
      })

      // 当前选中的项目ID
      const currentSelectedIds = currentSelected.map(item => item.id)

      // 获取已选但当前页面上没有的项目ID
      const notInCurrentPageIds = this.selectedProjectIds.filter(
          id => !this.mergeProjectData.some(item => item.projectsRow.projectId === id)
      )

      // 合并当前页选中的和不在当前页但已选中的
      const allSelectedIds = [...new Set([...currentSelectedIds, ...notInCurrentPageIds])]

      // 检查是否已有选定的项目类型
      if (this.selectedProjectType) {
        // 检查新选择的项目是否与现有类型不同
        const invalidSelections = currentSelected.filter(item =>
            (item.otuOrAsv && item.otuOrAsv !== this.selectedProjectType.otuOrAsv) ||
            (item.projectType && !this.isSameProjectType(item.projectType, this.selectedProjectType.projectType))
        )
        if (invalidSelections.length > 0) {
          this.$messageUi.error(`只能选择相同生物序列分类方法(${this.selectedProjectType.otuOrAsv})和相同引物类型(${this.selectedProjectType.projectType})的项目进行合并`)
          // 恢复选择状态，排除不符合类型的选择
          setTimeout(() => {
            this.selectedProjectIds = this.selectedProjectIds.filter(id =>
                !invalidSelections.some(invalid => invalid.id === id)
            )
            this.updateTableSelection()
          }, 0)
          return
        }
      }

      // 如果合并后超过10个，则只保留前10个
      if (allSelectedIds.length > 10) {
        this.$messageUi.warning('最多只能选择10个项目进行合并')
        setTimeout(() => {
          this.updateTableSelection()
        }, 0)
        return
      }

      // 更新selectedProjectIds
      this.selectedProjectIds = allSelectedIds
    },

    // 更新表格选中状态
    updateTableSelection() {
      // 清除所有选中状态
      this.$nextTick(() => {
        const tableInstance = this.$refs.elTable
          if (tableInstance) {
            tableInstance.clearSelection()

            // 根据selectedProjectIds重新设置选中状态
            this.mergeProjectData.forEach(row => {
              if (this.selectedProjectIds.includes(row.projectsRow.projectId)) {
                tableInstance.toggleRowSelection(row, true)
              }
            })
          }
      })
    },

    // 获取已选计数的样式
    getSelectedCountStyle() {
      if (this.selectedProjectIds.length < 2) {
        return 'color: #E6A23C; font-weight: bold;'
      } else if (this.selectedProjectIds.length >= 10) {
        return 'color: #F56C6C; font-weight: bold;'
      } else {
        return 'color: #409EFF; font-weight: bold;'
      }
    },

    // 提交合并项目
    async submitMergeProject() {
      if (this.selectedProjectIds.length < 2) {
        this.$message.warning('请至少选择两个项目进行合并')
        return
      }

      try {
        this.loadingMergeProject = true
        const res = await projectMerge(this.selectedProjectIds)
        this.loadingMergeProject = false
        if (res && res.code === 200) {
          this.$message.success('项目合并成功')
          // this.showMergeDialog = false
          // this.getData()
          this.$emit('updateData')
        } else {
          this.cancel()
          // this.showMergeDialog = false
        }
      } catch (error) {
        this.loadingMergeProject = false
        this.$message.error('项目合并失败')
        console.error(error)
      }
    },
    // 获取合并状态颜色
    getMergeStatusType(status) {
      switch (Number(status)) {
        case 0:
          return '';
        case 1:
          return 'danger';
        case 2:
          return 'info';
        default:
          return 'warning';
      }
    },
    // 获取合并状态文本
    getMergeStatusText(status) {
      switch (Number(status)) {
        case 0:
          return '未合并';
        case 1:
          return '已合并';
        case 2:
          return '合并项目';
        default:
          return '未知状态';
      }
    },
    // 获取otuOrAsv的标签类型
    getOtuAsvType(type) {
      if (type === 'OTU') {
        return 'success'
      } else if (type === 'ASV') {
        return 'warning'
      } else {
        return 'info'
      }
    },
    // 比较两个引物类型是否相同（支持管道符分隔）
    isSameProjectType(type1, type2) {
      if (!type1 || !type2) {
        return false
      }
      // 如果完全相等，直接返回true
      if (type1 === type2) {
        return true
      }
      // 将两个类型按管道符分割成数组
      const types1 = type1.split('|').map(t => t.trim()).filter(t => t)
      const types2 = type2.split('|').map(t => t.trim()).filter(t => t)
      // 检查是否有交集（只要有一个相同的元素就认为是相同类型）
      return types1.some(t1 => types2.includes(t1))
    },
    // 根据项目ID获取项目类型
    getProjectTypeById(projectId) {
      // 先在当前页中查找
      const project = this.mergeProjectData.find(item => item.projectsRow.projectId === projectId)
      if (project) {
        return {
          otuOrAsv: project.otuOrAsv,
          projectType: project.projectsRow.projectType
        }
      }

      // 如果当前页没有，尝试从选中的缓存中查找
      const cachedType = this.selectedProjectsCache.find(item => item.id === projectId)
      if (cachedType) {
        return {
          otuOrAsv: cachedType.otuOrAsv,
          projectType: cachedType.projectType
        }
      }

      return null
    },
    // 添加搜索与重置方法
    // 搜索合并项目
    searchMergeProject() {
      this.mergePage.currentNum = 1
      this.getMergeProjectData()
    },
    // 重置搜索条件
    resetMergeSearch() {
      this.mergeSearchForm = {
        projectId: '',
        contractNumber: '',
        otuOrAsv: ''
      }
      this.mergePage.currentNum = 1
      this.getMergeProjectData()
    },
    cancel() {
      this.$emit('update:showDialog')
    },
    handle() {
      this.$emit('submitData')
    },
  },
}
</script>

<style scoped>

</style>
